import isEmpty from "lodash/isEmpty"
import merge from "lodash/merge"
import keyBy from "lodash/keyBy"
import map from "lodash/map"
import mapValues from "lodash/mapValues"
import { compose, withPropsOnChange } from "recompose"
import { getCrewMembers } from "../../../api/entities/crewMembers"
import withApiTransport from "../../../api/apiTransport"

/**
 * плановые челы лежат в событии планера
 * бригады (реальные челы) брать из crew by visitId
 */

const enhance = compose(
  withPropsOnChange([`visits`], ({ visits }) => ({
    load: getCrewMembers,
    propName: `crewMembers`,
    payload: map(visits, `id`),
  })),
  withApiTransport,
  withPropsOnChange(
    [`humanResources`, `crewMembers`],
    ({ humanResources, crewMembers }) => {
      if (isEmpty(humanResources) && isEmpty(crewMembers)) {
        return {}
      }

      const planned = mapValues(keyBy(humanResources, `uuid`), resource => ({
        ...resource,
        planned: true,
      }))
      const actual = mapValues(keyBy(crewMembers, `extId`), resource => ({
        ...resource,
        actual: true,
      }))
      const preparedCrew = merge(planned, actual)

      return { preparedCrew }
    },
  ),
)

export default enhance
